import type { Localized } from '../types/content'

export const ui: Record<string, Localized> = {
  freeEstimate: { en: 'Get Free Estimate', es: 'Obtener Presupuesto Gratis' },
  freeEstimateToday: { en: 'Get Free Estimate Today', es: 'Obtener Presupuesto Gratis Hoy' },
  freeEstimateNow: { en: 'Get Free Estimate Now', es: 'Pedir Presupuesto Ahora' },
  callNow: { en: 'Call Now', es: 'Llamar Ahora' },
  call: { en: 'Call', es: 'Llamar' },
  whatsapp: { en: 'WhatsApp Us', es: 'Escríbenos por WhatsApp' },
  learnMore: { en: 'Learn more', es: 'Más información' },
  viewAllServices: { en: 'View all services', es: 'Ver todos los servicios' },
  viewFullGallery: { en: 'View full gallery', es: 'Ver galería completa' },
  before: { en: 'Before', es: 'Antes' },
  after: { en: 'After', es: 'Después' },
  dragToCompare: { en: 'Drag to compare', es: 'Desliza para comparar' },
  scope: { en: 'Scope', es: 'Alcance' },
  duration: { en: 'Duration', es: 'Duración' },
  result: { en: 'Result', es: 'Resultado' },
  quickLinks: { en: 'Quick Links', es: 'Enlaces Rápidos' },
  contact: { en: 'Contact', es: 'Contacto' },
  hours: { en: 'Hours', es: 'Horario' },
  serviceArea: { en: 'Service Area', es: 'Área de Servicio' },
  privacy: { en: 'Privacy Policy', es: 'Política de Privacidad' },
  terms: { en: 'Terms of Service', es: 'Términos de Servicio' },
  licensedInsured: { en: 'Licensed & Insured', es: 'Con Licencia y Asegurados' },
  yearsBadge: { en: '10+ Years Experience', es: '10+ Años de Experiencia' },
  familyOwned: { en: 'Family Owned', es: 'Negocio Familiar' },
  freeEstimatesBadge: { en: 'Free Estimates', es: 'Presupuestos Gratis' },
  menu: { en: 'Menu', es: 'Menú' },
  closeMenu: { en: 'Close menu', es: 'Cerrar menú' },
  language: { en: 'Language', es: 'Idioma' },
}

export const formLabels: Record<string, Localized> = {
  heading: { en: 'Request your free estimate', es: 'Solicita tu presupuesto gratis' },
  subheading: {
    en: 'Tell us about your project and we will call you back the same business day.',
    es: 'Cuéntanos sobre tu proyecto y te llamamos el mismo día hábil.',
  },
  name: { en: 'Full name', es: 'Nombre completo' },
  phone: { en: 'Phone number', es: 'Teléfono' },
  email: { en: 'Email', es: 'Correo electrónico' },
  service: { en: 'Service needed', es: 'Servicio que necesitas' },
  servicePlaceholder: { en: 'Select a service', es: 'Selecciona un servicio' },
  address: { en: 'Property address', es: 'Dirección de la propiedad' },
  preferredDate: { en: 'Preferred visit date (optional)', es: 'Fecha preferida de visita (opcional)' },
  message: { en: 'Project details', es: 'Detalles del proyecto' },
  messagePlaceholder: {
    en: 'Rooms, square footage, timeline, anything else we should know…',
    es: 'Habitaciones, metros, tiempos, o cualquier detalle importante…',
  },
  submit: { en: 'Send my request', es: 'Enviar mi solicitud' },
  submitting: { en: 'Sending…', es: 'Enviando…' },
  successTitle: { en: 'Request received', es: 'Solicitud recibida' },
  successBody: {
    en: 'Thank you. A member of our family team will call you at the number you provided, usually within a few hours.',
    es: 'Gracias. Un miembro de nuestro equipo familiar te llamará al número que nos diste, normalmente en pocas horas.',
  },
  sendAnother: { en: 'Send another request', es: 'Enviar otra solicitud' },
  errorRequired: { en: 'This field is required', es: 'Este campo es obligatorio' },
  errorEmail: { en: 'Enter a valid email address', es: 'Ingresa un correo válido' },
  errorPhone: { en: 'Enter a valid phone number', es: 'Ingresa un teléfono válido' },
  errorSummary: {
    en: 'Please fix the highlighted fields before sending.',
    es: 'Corrige los campos marcados antes de enviar.',
  },
  prefer: { en: 'Prefer to talk right now?', es: '¿Prefieres hablar ahora mismo?' },
}
